<script setup>
import { inject } from 'vue';

const field = inject('field');
</script>

<template>
    <div v-if="!field.hideLabel">
        <label class="text-sm font-medium" :for="field.id">
            {{ field.label }} <span v-if="field.required && field.markAsRequired" class="text-danger">*</span>
        </label>
    </div>
</template>
